export const DWF_LEARNING_USERID = 'DWF_LEARNING_USERID';
export const DWF_PROXY_TOKEN = 'DWF_PROXY_TOKEN';
export const DWF_USER_EMAIL = 'DWF_USER_EMAIL';
export const DWF_USER_ROLE = 'DWF_USER_ROLE';
export const AMBASSADOR_ROLE = 'ambassador';
export const DWF_PAGEVIEW_COUNT = 'DWF_PAGEVIEW_COUNT';

// Number of pageviews an anonymous visitor gets before being
// required to log in or register.
export const ANONYMOUS_PAGEVIEW_LIMIT = 5;

export const AvailableGrades = [
  "JK",
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12"
]

export const IndigenousGroup = [
  "First Nations",
  "Inuit",
  "Métis",
  "None of the Above"
]


// Artist Ambassador Scheduling has been re-enabled.
// Flip this flag to false if access needs to be paused again.
export const ARTIST_AMBASSADOR_SCHEDULING_ENABLED = true;
